import { render, staticRenderFns } from "./SocialNetworkSharingSettings.vue?vue&type=template&id=a0bbaf56"
import script from "./SocialNetworkSharingSettings.vue?vue&type=script&lang=js"
export * from "./SocialNetworkSharingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports